import axios from "axios";
import { baseURL } from "../config/index";

export async function AdminLogin(credentials) {
  try {
    const response = await axios.post(
      `${baseURL}/api/v1/admin/login`,
      credentials,
      { withCredentials: true },
    );


    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}
